import React from "react";
import HomeData from "../../../data/csr.json";
import SectionTitle from "../../../components/section-title";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import PropTypes from "prop-types";

const CSRImageContainer = ({ classOption = "mt-10 mt-lg-0 pt-5 pb-10" }) => {
    SwiperCore.use([Autoplay, Navigation, Pagination]);
    const pagination = {
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + 1 + "</span>";
        },
    };
    const swiperOption = {
        loop: false,
        rewind: "true",
        navigation: false,
        speed: 2500,
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: { pagination },
        autoplay: {
            delay: 2000,
            disableOnInteraction: true,
        },
        modules: { Pagination, Navigation },
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1,
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 1,
            },
            // when window width is >= 640px
            640: {
                slidesPerView: 3,
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 3,
            },
            // when window width is >= 992px
            992: {
                slidesPerView: 3,
            },
        },
    };
    return (
        <div className={`brand-section y-background-color ${classOption}`}>
            <div className="container">
                <div className="row mb-5 ">
                    <div className="col-xl-12 col-lg-12 mx-auto text-center">
                        <SectionTitle
                            classOption="title-section text-center mb-5"
                            subTitle=""
                            title="<span class='text-primary'>Workforce</span> Participation"
                            excerptClassOption="null"
                            excerpt=""
                        />
                    </div>
                </div>
                {/* <div className="brand-carousel mb-n7">
                    <a href="/" rel="noreferrer">
                        <img
                            className=""
                            src="/images/csr/CSRTimes/04.png"
                            alt="shape"
                            style={{
                                maxWidth: "700px",
                                width: "30%",
                                height: "auto",
                                boxShadow: "0px 0px 5px 0px rgb(0 0 0)",
                                borderRadius: "20px",
                                border: "2px solid white",
                            }}
                        />
                    </a>
                </div> */}

                <div className="testimonial-carousel position-relative">
                    <Swiper className="mySwiper pb-5" {...swiperOption}>
                        {HomeData[0].CSRTimes &&
                            HomeData[0].CSRTimes.map((single, key) => {
                                return (
                                    <SwiperSlide
                                        key={key}
                                        className="px-2 py-2"
                                    >
                                        <img
                                            className="home-banner-shape"
                                            src={single.image}
                                            alt="shape"
                                            style={{
                                                width: "100%",
                                                boxShadow:
                                                    "0px 0px 5px 0px rgb(0 0 0)",
                                                borderRadius: "10px",
                                                border: "2px solid white",
                                            }}
                                        />
                                    </SwiperSlide>
                                );
                            })}
                    </Swiper>
                </div>
            </div>
        </div>
    );
};

CSRImageContainer.propTypes = {
    classOption: PropTypes.string,
};

export default CSRImageContainer;
